import dayjs from "dayjs";

// How far back a channel's data can be asked for. The reader's own default is
// three months whenever a request carries no start date, so every window here
// has to be sent explicitly.
const DEFAULT_HISTORY_MONTHS = 3;

// Stands in for "from the beginning": the reader needs a date, and nothing in
// the collection predates this.
const ARCHIVE_START = "2019-01-01";

// Channels with no limit — the whole archive.
const UNLIMITED_HISTORY_CHANNELS = [
  "V5CZ8ZWa9j",
  "2iLhi7EeEq",
  "AwG6zFgabB",
  "5eA3XHqr4P",
  "CbNrhF5wpG",
];

function isUnlimited(channelId) {
  return UNLIMITED_HISTORY_CHANNELS.includes(String(channelId || "").trim());
}

// Earliest day this channel may be asked about, as a reader "start" parameter.
export function historyStartKey(channelId) {
  return isUnlimited(channelId)
    ? ARCHIVE_START
    : dayjs().subtract(DEFAULT_HISTORY_MONTHS, "month").format("YYYY-MM-DD");
}

// The same day as a Date, for the pickers' min.
export function historyStartDate(channelId) {
  return dayjs(historyStartKey(channelId), "YYYY-MM-DD").startOf("day").toDate();
}

// What a channel opens with. A year of minute data is several megabytes and the
// page waits for it, so the recent stretch — which is what every default view
// shows — is fetched first and the rest follows in the background.
const RECENT_DAYS = 45;

// Both halves as reader parameters. The reader's end is exclusive (_created_at
// $lt), so the backfill ending on the same day the first request starts leaves
// no gap and no overlap. backfill is null when the whole window is recent
// anyway, which is every channel on the default three months.
export function historyFetchPlan(channelId) {
  const full = historyStartKey(channelId);
  const recent = dayjs().subtract(RECENT_DAYS, "day").format("YYYY-MM-DD");

  if (!dayjs(full, "YYYY-MM-DD").isBefore(dayjs(recent, "YYYY-MM-DD"), "day")) {
    return { first: full, backfill: null };
  }
  return { first: recent, backfill: { start: full, end: recent } };
}
